import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useUser = () => {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const res = await axios.get('/api/auth/me');
        return res.data;
        // eslint-disable-next-line unused-imports/no-unused-vars
      } catch (err) {
        // we expect 401s or similar
        return null; // now it's "data: null" instead of error
      }
    },
    retry: false,
  });
};
